import React from 'react';

import { Header as SectionHeader } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import type { DimensionValue } from 'react-native';

import Link from 'components/link';
import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

type CardWrapProps = BoxProps & {
  bg?: string;
  bgColor?: string;
  color?: string;
  flexBasis?: DimensionValue;
  flexGrow?: number;
  flexShrink?: number;
};

export const CardWrap = ({
  bg,
  bgColor,
  color: _color,
  flexBasis,
  flexGrow,
  flexShrink,
  style,
  ...props
}: CardWrapProps) =>
  React.createElement(Box, {
    ...props,
    style: [
      styles.cardWrap,
      {
        backgroundColor: bgColor || bg,
        flexBasis,
        flexGrow,
        flexShrink,
      },
      style,
    ],
  });

export const ImageLink = Link.withConfig(() => ({
  width: 'full',
}));

export const TextWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.textWrapper, style] });

export const ButtonWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.buttonWrapper, style] });

export const Header = SectionHeader.withConfig(() => ({
  variant: 'headerTwo',
  marginBottom: 2,
  focusable: true,
  accessible: true,
  accessibilityRole: 'header',
}));

export const Description = withTypography({
  variant: 'copyTwo',
  accessible: true,
});

export const Terms = Link.withConfig(() => ({
  isUnderlined: true,
  isInline: true,
  variant: 'copyTwo',
  marginY: 2,
}));

const styles = StyleSheet.create({
  buttonWrapper: {
    alignSelf: 'flex-start',
    marginTop: spacing.$4,
  },
  cardWrap: {
    borderRadius: 16,
    elevation: 2,
    flex: 1,
    marginHorizontal: spacing.$1,
    marginVertical: spacing.$2,
    shadowColor: primitive.$black,
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
  },
  textWrapper: {
    flex: 1,
    justifyContent: 'space-between',
    padding: spacing.$4,
    width: '100%',
  },
});
